<div class="skeleton" [ngStyle]="{
  'width.px': width,
  'height.px': height,
  'border-radius.px': borderRadius
}"></div>
